/* Controllers */

var ctrl = angular.module('psrApp.controllers',[]);

ctrl.controller('HomeCtrl', ['environment','$scope', function ( environment, $scope ) {
	$scope.environment = environment;
}]);

ctrl.controller('NavigationHeaderCtrl', ['$scope', 'customHttp','environment', '$location', '$anchorScroll', function ( $scope, customHttp, environment, $location, $anchorScroll ) {

	$scope.environment = environment;

	$scope.isCollapsed = true;
	$scope.navigationMobileMenu = true;

	$scope.selected = null;

    $scope.scrollTop = function() {

        $location.hash('nav-anchor')

        $anchorScroll();
    };

	$scope.itemClass = function( item ) {
		return item === $scope.selected ? 'ativo' : undefined;
	};

    $scope.isSelected = function(item){
      	return item === $scope.selected ? true : false;
    };

    $scope.setSelected = function(item){
      	$scope.selected = item;
    };

    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/navigation-love.json').then(function(data) {
    	$scope.navAmor = data;
   	});

    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/navigation-self-knowledge.json').then(function(data){
      $scope.navAutoconhecimento = data;
    });

    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/navigation-future.json').then(function(data){
      $scope.navFuturo = data;
    });

    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/navigation-house.json').then(function(data){
      $scope.navCasa = data;
    });

    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/navigation-family.json').then(function(data){
      $scope.navFamilia = data;
    });

    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/navigation-health.json').then(function(data){
      $scope.navSaude = data;
    });

    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/navigation-food.json').then(function(data){
      $scope.navAlimentacao = data;
    });

    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/navigation-career.json').then(function(data){
      $scope.navCarreira = data;
    });

    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/navigation-money.json').then(function(data){
      $scope.navDinheiro = data;
    });

    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/navigation-self-esteem.json').then(function(data){
      $scope.navAutoestima = data;
    });

    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/navigation-spirituality.json').then(function(data){
      $scope.navEspiritualidade = data;
    });

}]);

ctrl.controller('FreeServicesHighlightCtrl', ['$scope','environment', function ($scope, environment) {
	$scope.range = function(start, end) {
		var input = [];
		start = parseInt(start);
		end = parseInt(end);
		var direction = ( start <= end ) ? 1 : -1;
		while (start <= end) {
			if ( start < 10 ) {
				input.push('0' + start);
			} else {
				input.push(start);
			}
			start += direction;
		}
		return input;
	};
	$scope.environment = environment;
}]);

ctrl.controller('ArticlesHighlightCtrl', ['$scope','customHttp', function ( $scope, customHttp ) {
    customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/articles-highlight.json').then(function(data){
        $scope.articles = data;
    });
}]);

ctrl.controller('ServicesHighlightCtrl', ['$scope','customHttp', function ( $scope, customHttp ) {
	$scope.selected = 0
	$scope.setSelected = function(value){
		$scope.selected=value;
	};

  	customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/services-highlight.json').then(function(data){
    	$scope.services = data;
  	});
 }]);

ctrl.controller('ShoppingHighlightCtrl', ['$scope','customHttp','environment', function ( $scope, customHttp, environment ) {
  customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/shopping-highlight.json').then(function(data){
    $scope.shopping = data;
  });
  $scope.environment = environment;
}]);

ctrl.controller('MainHighlightCtrl', ['$scope','customHttp', function ( $scope, customHttp ) {
  customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/main-highlight.json').then(function(data){
    $scope.carouselContent = data.carouselContent;
    $scope.contentHighlightMainSolo = data.contentHighlightMainSolo;
    $scope.selected = $scope.carouselContent[0];
  });

  	$scope.select= function(item) {
		$scope.selected = item;
	};
	$scope.itemClass = function(item) {
		return item === $scope.selected ? 'ativo' : undefined;
	};
	$scope.loadImage = function(item) {
		return item === $scope.selected ? true : false;
    };
}]);

ctrl.controller('GroupHighlightCtrl', ['$scope','customHttp', function ( $scope, customHttp ) {
  customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/group-highlight.json').then(function(data){
    $scope.groupMain = data.main;
    $scope.groupList1 = data.group1;
    $scope.groupList2 = data.group2;
  });
}]);

ctrl.controller('ForumHighlightCtrl', ['$scope','customHttp','environment',  function ( $scope, customHttp, environment ) {
  customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/forum-highlight.json' ).then(function(data){
    $scope.forum = data;
  });
  $scope.environment = environment;
}]);

ctrl.controller('ChannelHighlightCtrl', ['$scope', '$attrs','customHttp', function ( $scope, $attrs, customHttp ) {
	customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/'+$attrs.channel+'-highlight.json' ).then(function(data){
      $scope.content = data;
    });
}]);

ctrl.controller('NavigationFooterCtrl', ['$scope','environment', function ( $scope, environment ) {
	$scope.environment = environment;
}]);

ctrl.controller('AuthorHighlightCtrl', ['$scope','environment', function ( $scope, environment ) {
	$scope.carouselInterval = 5000;

     var slides = [
     	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/2.png',
	        name: 'Alexey Dodsworth',
	        specialty: [ { title: 'Astrologia,', redirectUrl: '/astrologia' }, { title: 'Tarot,', redirectUrl: '/tarot' }, { title: 'Runas', redirectUrl: '/runas/runas-e-vida-material' } ],
	        redirectUrl: '/alexey-dodsworth-a2',
	        article: { title: 'Combinação de elementos: veja exemplos', redirectUrl: '/combinacao-de-elementos-veja-exemplos-m2933', color: 'purple' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/3.png',
	        name: 'Yubertson Miranda',
	        specialty: [ { title: 'Numerologia,', redirectUrl: '/numerologia' }, { title: 'Sonhos', redirectUrl: '/interpretacao-de-sonhos' } ],
	        redirectUrl: '/yubertson-miranda-a3',
	        article: { title: 'Combinação numerológica do casal', redirectUrl: '/combinacao-numerologica-do-casal-m5057', color: 'pink' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/7.png',
	        name: 'Leo Chioda',
	        specialty: [ { title: 'Tarot', redirectUrl: '/tarot' } ],
	        redirectUrl: '/leo-chioda-a7',
	        article: { title: 'Como fazer um bom jogo de Tarot?', redirectUrl: '/como-fazer-um-bom-jogo-de-tarot-m5007', color: 'orange' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/4.png',
	        name: 'Ceci Akamatsu',
	        specialty: [ { title: 'Amor,', redirectUrl: '/amor' }, { title: 'Outras Terapias', redirectUrl: '/outras-terapias' } ],
	        redirectUrl: '/ceci-akamatsu-a4',
	        article: { title: 'Por que os homens não querem compromisso?', redirectUrl: '/por-que-os-homens-nao-querem-compromisso-m5049', color: 'pink' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/41.png',
	        name: 'Solange Lima',
	        specialty: [ { title: 'Aromaterapia,', redirectUrl: '/aromaterapia' }, { title: 'Cromoterapia', redirectUrl: '/cromoterapia' } ],
	        redirectUrl: '/solange-lima-a41',
	        article: { title: 'Aromaterapia para esquentar a relação', redirectUrl: '/aromaterapia-para-esquentar-a-relacao-m5087', color: 'pink' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/49.png',
	        name: 'Vanessa Tuleski',
	        specialty: [ { title: 'Astrologia', redirectUrl: '/astrologia' } ],
	        redirectUrl: '/vanessa-tuleski-a49',
	        article: { title: 'Junho trará à tona algumas tensões de abril', redirectUrl: '/junho-trara-a-tona-algumas-tensoes-de-abril-m5051', color: 'orange' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/55.png',
	        name: 'Roberta Struzani',
	        specialty: [ { title: 'Sexualidade,', redirectUrl: '/amor/sexualidade' }, { title: 'Autoestima', redirectUrl: '/beleza/autoestima' } ],
	        redirectUrl: '/roberta-struzani-a55',
	        article: { title: 'Existe ponto G? Aproveite para descobrir o seu', redirectUrl: '/existe-ponto-g-aproveite-para-descobrir-o-seu-m5079', color: 'pink' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/85.png',
	        name: 'Melissa Setubal',
	        specialty: [ { title: 'Saúde,', redirectUrl: '/saude-e-alimentacao' }, { title: 'Alimentação', redirectUrl: '/saude-e-alimentacao' } ],
	        redirectUrl: '/melissa-setubal-a85',
	        article: { title: 'Receita de sopa de missô (Missoshiro)', redirectUrl: '/receita-de-sopa-de-misso-missoshiro-m5149', color: 'blue' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/21.png',
	        name: 'Simone Kobayashi',
	        specialty: [ { title: 'Cristais,', redirectUrl: '/cristais' }, { title: 'Reiki', redirectUrl: '/reiki' } ],
	        redirectUrl: '/simone-kobayashi-a21',
	        article: { title: 'Os Chakras menos conhecidos', redirectUrl: '/os-chakras-menos-conhecidos-m5115', color: 'blue' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/18.png',
	        name: 'Celia Lima',
	        specialty: [ { title: 'Psicologia e Coaching', redirectUrl: '/psicologia-e-coaching' } ],
	        redirectUrl: '/celia-lima-a18',
	        article: { title: 'Futebol, política e religião se discutem?', redirectUrl: '/futebol-politica-e-religiao-se-discutem-m5151', color: 'purple' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/14.png',
	        name: 'Regina Restelli',
	        specialty: [ { title: 'Meditação', redirectUrl: '/meditacao' } ],
	        redirectUrl: '/regina-restelli-a14',
	        article: { title: 'Depoimento: assumi meus cabelos brancos', redirectUrl: '/depoimento-assumi-meus-cabelos-brancos-m4907', color: 'salmon' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/88.png',
	        name: 'Aline Mendes',
	        specialty: [ { title: 'Feng Shui', redirectUrl: '/feng-shui' } ],
	        redirectUrl: '/aline-mendes-a88',
	        article: { title: 'Dicas para usar espelhos na decoração', redirectUrl: '/dicas-para-usar-espelhos-na-decoracao-m4054', color: 'yellow' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/82.png',
	        name: 'Tahiana Ferraço',
	        specialty: [ { title: 'Aromaterapia', redirectUrl: '/aromaterapia' } ],
	        redirectUrl: '/tahiana-ferraco-a82',
	        article: { title: 'Laranja: o óleo essencial da alegria', redirectUrl: '/laranja-o-oleo-essencial-da-alegria-m4909', color: 'blue' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/53.png',
	        name: 'Giane Portal',
	        specialty: [ { title: 'Astrologia,', redirectUrl: '/astrologia' }, { title: 'Tarot', redirectUrl: '/tarot' } ],
	        redirectUrl: '/giane-portal-a53',
	        article: { title: 'A Lua: enganos, ilusões e fantasias', redirectUrl: '/a-lua-enganos-ilusoes-e-fantasias-m5055', color: 'purple' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/33.png',
	        name: 'Juliana Garcia',
	        specialty: [ { title: 'Psicologia e Coaching', redirectUrl: '/psicologia-e-coaching' } ],
	        redirectUrl: '/juliana-garcia-a33',
	        article: { title: 'Você conhece seus talentos?', redirectUrl: '/voce-conhece-seus-talentos-m4963', color: 'purple' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/45.png',
	        name: 'Amanda Regina',
	        specialty: [ { title: 'Alimentação', redirectUrl: '/saude-e-alimentacao' } ],
	        redirectUrl: '/amanda-regina-a45',
	        article: { title: 'Gengibre previne resfriado, dor de garganta e enjoos', redirectUrl: '/gengibre-previne-resfriado-dor-de-garganta-e-enjoos-m4989', color: 'blue' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/52.png',
	        name: 'Marcia Fervienza',
	        specialty: [ { title: 'Astrologia', redirectUrl: '/astrologia' } ],
	        redirectUrl: '/marcia-fervienza-a52',
	        article: { title: 'Astrologia indica época certa para engravidar', redirectUrl: '/astrologia-indica-epoca-certa-para-engravidar-m4579', color: 'yellow' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/47.png',
	        name: 'Carla Panisset',
	        specialty: [ { title: 'Psicologia e Coaching', redirectUrl: '/psicologia-e-coaching' } ],
	        redirectUrl: '/carla-panisset-a47',
	        article: { title: 'Autoconhecimento amplia alegria de viver', redirectUrl: '/autoconhecimento-amplia-alegria-de-viver-m5121', color: 'purple' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/28.png',
	        name: 'Marcelo Guerra',
	        specialty: [ { title: 'Outras terapias', redirectUrl: '/outras-terapias' } ],
	        redirectUrl: '/marcelo-guerra-a28',
	        article: { title: 'Dependentes de amor e sexo', redirectUrl: '/dependentes-de-amor-e-sexo-m4987', color: 'pink' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/73.png',
	        name: 'Thais Khoury',
	        specialty: [ { title: 'Interpretação de Sonhos', redirectUrl: '/interpretacao-de-sonhos' } ],
	        redirectUrl: '/thais-khoury-a73',
	        article: { title: 'O que significa sonhar com morte?', redirectUrl: '/o-que-significa-sonhar-com-morte-m4168', color: 'purple' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/36.png',
	        name: 'Thaise Titon',
	        specialty: [ { title: 'Yoga', redirectUrl: '/yoga' } ],
	        redirectUrl: '/thaise-titon-a36',
	        article: { title: 'Pratique a saudação ao sol', redirectUrl: '/pratique-a-saudacao-ao-sol-m2277', color: 'blue' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/24.png',
	        name: 'Maria Cristina',
	        specialty: [ { title: 'Psicologia e Coaching', redirectUrl: '/psicologia-e-coaching' } ],
	        redirectUrl: '/maria-cristina-a24',
	        article: { title: 'Supere sentimentos e dores por meio da arte', redirectUrl: '/supere-sentimentos-e-dores-por-meio-da-arte-m4911', color: 'pink' }
      	},
      	{
	        image: environment.static + '/static/psr/br/framework/nef/img/shared/collaborators/34.png',
	        name: 'Clarissa De Franco',
	        specialty: [ { title: 'Astrologia', redirectUrl: '/astrologia' } ],
	        redirectUrl: '/clarissa-de-franco-a34',
	        article: { title: 'Confissões de uma mulher de verdade', redirectUrl: '/confissoes-de-uma-mulher-de-verdade-m2178', color: 'purple' }
      	}
    ];
    $scope.totalCollaborators = 73;
    var array = [], count = 6, total = slides.length, chunkIndex, isFirst, i;
    for (i = 0; i < total; i++) {
      chunkIndex = parseInt( i / count);
      isFirst = ( i % count == 0 );
      if (isFirst) {
        array[chunkIndex] = [];
      }
      array[chunkIndex].push(slides[i]);
    }
    $scope.slides = array;
}]);

ctrl.controller('EventsHighlightCtrl', ['$scope','customHttp', function ( $scope, customHttp ) {
	customHttp.get('/media/psr/framework/admin/app/temporaryJsonV2/events-highlight.json').then(function(data){
		$scope.events = data;
	});
}]);
